export default __webpack_public_path__ + "static/media/auto loan table.537fe387.png";